import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { usePortfolio } from '../context/PortfolioContext';
export function CaseStudyMobileHeader() {
  // REMOVED: This component is no longer needed
  // The "Back to Chat" button is now handled directly in the case study pages (above h1)
  // The regular CaseStudyHeader shows logo + menu on mobile
  return null;
}